export var PublisherBanListType;
(function (PublisherBanListType) {
    PublisherBanListType["Drop"] = "dropBanList";
    PublisherBanListType["Publisher"] = "publisherBanList";
})(PublisherBanListType || (PublisherBanListType = {}));
